import {
	CATEGORY_RESTORE,
	CATEGORY_RESTORE_DONE,
	CATEGORY_RESTORE_LIST,
	CATEGORY_RESTORE_LIST_SUCCESS,
	CATEGORY_RESTORE_PRODUCTS,
	CATEGORY_RESTORE_PRODUCTS_SUCCESS,
	CATEGORY_RESTORE_RESET,
} from '../constants/category';

// Catégories supprimées proposées à la restauration, et les produits que
// chacune portait. Les produits sont chargés à la sélection : ils dépendent de
// la catégorie choisie, et la liste ne sert qu'une fois.
const initialState = {
	loading: false,
	loadingProducts: false,
	restoring: false,
	// null tant que la liste n'a pas été demandée : distinct d'une liste vide,
	// qui signifie qu'aucune catégorie n'a été supprimée.
	categories: null,
	// Indexé par identifiant de catégorie : rouvrir une catégorie déjà consultée
	// ne redemande rien au serveur.
	products: {},
};

export default function categoryRestoreReducer(state = initialState, action) {
	switch (action.type) {
		case CATEGORY_RESTORE_LIST:
			return { ...state, loading: true };
		case CATEGORY_RESTORE_LIST_SUCCESS:
			return { ...state, loading: false, categories: action.categories };
		case CATEGORY_RESTORE_PRODUCTS:
			return { ...state, loadingProducts: true };
		case CATEGORY_RESTORE_PRODUCTS_SUCCESS:
			return {
				...state,
				loadingProducts: false,
				products: {
					...state.products,
					[action.id_category]: action.products,
				},
			};
		case CATEGORY_RESTORE:
			return { ...state, restoring: true };
		case CATEGORY_RESTORE_DONE:
			return { ...state, restoring: false };
		case CATEGORY_RESTORE_RESET:
			return initialState;
		default:
			return state;
	}
}
